import { render, staticRenderFns } from "./RestrictionsCorp.vue?vue&type=template&id=05489cee"
import script from "./RestrictionsCorp.vue?vue&type=script&lang=ts"
export * from "./RestrictionsCorp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports